module.exports = __webpack_public_path__ + "static/img/kf_cloud_00012.25e4d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00012.jpg
// module id = 183
// module chunks = 1